import storage from 'viralstyle-ui/src/storage';

import hateoas from 'viralstyle-ui/src/hateoas';

export const lookupOrder = async ({ rootState, state, dispatch, commit }) => {
  let lookupNumber = rootState.trackOrder.orderId;

  if (rootState.isWhitelabel && rootState.trackOrder.orderId.indexOf('VS') === -1) {
    lookupNumber = `VS${rootState.trackOrder.orderId}`;
  }

  let url = hateoas.url('get_order_details', { lookupNumber });

  if (rootState.trackOrder.zip) url = `${url}?zip=${rootState.trackOrder.zip}`;

  let response = await dispatch('get', url);

  commit('updateState', { object: state, property: 'orderGroup', value: response.data });

  return response;
};

export const getOrderGroup = async ({ state, dispatch, commit }, url) => {
  let response = await dispatch('get', url);

  commit('updateState', { object: state, property: 'orderGroup', value: response.data });

  storage.set('order-group-url', url);

  response = await dispatch('get', response.data._links.get_order_campaign_tracking);

  commit('updateState', { object: state.orderGroup, property: 'tracking', value: response.data });

  return response;
};

export const getFulfillmentInfo = async ({ state, dispatch, commit }, order) => {
  let response = await dispatch('get', order._links.fulfillment_tracking);

  commit('updateState', { object: state, property: 'currentFulfillmentInfo', value: response.timeline || null });

  if (!response.timeline) commit('addNotification', 'There was no history found for this order. Please try again later.')
  else commit('lockScroll', true);

  return response;
};

export const patchAddress = async ({ state, dispatch }, { customer, token }) => {
  let payload = {
    name: customer.name,
    phone_number: customer.phone,
    postal_code: customer.postal_code,
    street_1: customer.street_1,
    street_2: customer.street_2,
    city: customer.city,
    province: customer.province,
    country: customer.country,
  };

  if (token) payload.token = token;

  let response = await dispatch('patch', {
    apiUrl: state.orderGroup._links.update_address,
    payload,
  });

  response = await dispatch('getOrderGroup', response.order);

  return response;
};